import CancelablePromise from 'bluebird';
import getHyliaApiClient from 'clients/hylia-api';
import { PatientOverviewDto } from '@peartherapeutics/hylia-api-client';

CancelablePromise.config({
  cancellation: true,
});

export const getPatientOverview = async (
  patientId: string,
  accessRightId: string,
): Promise<PatientOverviewDto> => {
  const api = await getHyliaApiClient();
  const overview = await api.getPatientOverview(patientId, accessRightId);
  return overview.data;
};

export const overviewService = {
  getPatientOverview,
};
